import { Box, Flex, Image, Text } from '@chakra-ui/react';
import AppCard from 'presentation/components/shared/card/AppCard';
import { Color } from 'presentation/theme/colorScheme';
import { FC } from 'react';

interface Props {
  title: string;
  subtitle1: string;
  subtitle2: string;
  image: string;
}

const StrategyIntroCard: FC<Props> = ({
  title,
  subtitle1,
  subtitle2,
  image,
}) => {
  return (
    <AppCard
      pos="relative"
      bgColor={Color.Primary500}
      overflow="hidden"
      h="155px"
    >
      <Image position="absolute" src={image} right="0" top="0" h="100%" />
      <Box
        position="absolute"
        left="0"
        top="0"
        zIndex={3}
        w="100%"
        h="100%"
        bgImage="linear-gradient(360deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0) 100%)"
      />
      <Flex
        h="100%"
        zIndex={5}
        position="relative"
        flexDir="column"
        justifyContent="flex-end"
        py="15px"
        px="20px"
      >
        <Text w="200px" color={Color.OnPrimary} fontWeight={800} fontSize="22px" mb="5px">
          {title}
        </Text>
        <Text color={Color.OnPrimary} fontWeight={700} fontSize="26px" mb="5px">
          {subtitle1}
        </Text>
        <Text color={Color.OnPrimary}>
          {subtitle2}
        </Text>
      </Flex>
    </AppCard>
  );
};

export default StrategyIntroCard;
